"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentFilter = exports.notEmptyIpfsContent = exports.isEmptyIpfsContent = void 0;
const utils_1 = require("@subsocial/utils");
const isEmptyIpfsContent = (struct) => (0, utils_1.notDef)(struct) || (0, utils_1.isEmptyObj)(struct.content);
exports.isEmptyIpfsContent = isEmptyIpfsContent;
const notEmptyIpfsContent = (struct) => !(0, exports.isEmptyIpfsContent)(struct);
exports.notEmptyIpfsContent = notEmptyIpfsContent;
function contentFilter({ structs, withContentOnly }) {
    if (withContentOnly) {
        return structs.filter(exports.notEmptyIpfsContent);
    }
    return structs;
}
exports.contentFilter = contentFilter;
